import apiClient from '@/services/apiClient';
import { toast } from 'sonner';

const B = '/grn';
const d = (p) => p.then((r) => r.data);
export const grnErr = (e, fb) => e?.response?.data?.detail || fb;

export const grnApi = {
  toFinalise: (params) => d(apiClient.get(`${B}/to-finalise`, { params })),
  delivery: (entryId) => d(apiClient.get(`${B}/delivery/${entryId}`)),
  finalise: (entryId) => d(apiClient.post(`${B}/finalise/${entryId}`)),
  list: (params) => d(apiClient.get(`${B}/list`, { params })),
  booked: (id, booked) => d(apiClient.post(`${B}/${id}/booked`, { booked })),
  reopen: (id, reason) => d(apiClient.post(`${B}/${id}/reopen`, { reason })),
  cancel: (id, reason) => d(apiClient.post(`${B}/${id}/cancel`, { reason })),
};

export const money = (v) => `₹${Number(v || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const qtyText = (byUnit) => Object.entries(byUnit || {}).map(([u, q]) => `${Number(q).toLocaleString('en-IN', { maximumFractionDigits: 3 })} ${u}`).join(' · ') || '—';
export const when = (iso) => (iso ? new Date(iso).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—');
const role = () => { try { return JSON.parse(localStorage.getItem('user') || '{}'); } catch { return {}; } };
export const isGrnAdmin = () => ['Admin', 'Super Admin', 'Site Admin', 'super_admin'].includes(role().role);
export const isAccounts = () => isGrnAdmin() || (role().sections || []).some((s) => String(s).toLowerCase().includes('account'));

export async function openGrnPdf(g) {
  try {
    const r = await apiClient.get(`${B}/${g.grn_id}/pdf`, { responseType: 'blob' });
    const url = URL.createObjectURL(r.data.type ? r.data : new Blob([r.data], { type: 'application/pdf' }));
    const a = document.createElement('a');
    a.href = url; a.target = '_blank'; a.rel = 'noopener';
    a.download = `${g.grn_number.replace(/\//g, '-')}${g.revision ? `_R${g.revision}` : ''}.pdf`;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    toast.error('Could not get the GRN PDF');
  }
}
